import serialize from 'form-serialize'
import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form'
import { formatMoney } from '@shopify/theme-currency'

const classes = {
  hide: 'hide'
}

const selectors = {
  productForm     : '.product__form',
  optionsDropdown : '[data-single-option-selector]',
  selectedVariant : '[data-product-select]',
  priceWrapper    : '[data-price-wrapper]',
  productPrice    : '[data-product-price]',
  comparePrice    : '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  stockValidation : '.product__out-of-stock'
}

let variants = []

window.PStemplates.loadProduct = function () {

  const productFormElement = document.querySelector(selectors.productForm)

  // Create colour swatches
  window.setSwatches(productFormElement.dataset.productHandle)

  // Update variant
  fetch(`/products/${ productFormElement.dataset.productHandle }.js`)
  .then(response => {
    return response.json()
  })
  .then(productJSON => {
    variants = productJSON.variants
    renderDropdownCombinations(true)
    new ProductForm(productFormElement, productJSON, {
      onOptionChange
    })
  })

  // Add to cart
  productFormElement.addEventListener('submit', e => {
    fetch('/cart/add.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      method: 'post',
      body: new URLSearchParams(serialize(productFormElement))
    })
    .then(response => response.json())
    .then(data => {
      if (data.status == 422) {
        document.querySelector(selectors.stockValidation).classList.add('show')
        setTimeout(() => {
          document.querySelector(selectors.stockValidation).classList.remove('show')
        }, 2500)
      } else {
        window.PSVueCart.$refs.cart.buildCart()
        window.PSVueCart.$refs.cart.popInOut()
        if (window._learnq && window.item) {
          window._learnq.push(['track', 'Added to Cart', item])
        }
      }
    })

    e.preventDefault()
  })

  // Product Recommendations
  if (document.querySelector('.product__recommendations')) {
    fetch(`/recommendations/products.json?product_id=${ productFormElement.dataset.productId }&limit=8`)
    .then(response => response.json())
    .then(({ products }) => {
      if (!products.length > 0) return
      products.forEach((product, idx) => {
        let product_item = document.createElement('div')
        product_item.classList.add('product-item')
        if (idx === 0) product_item.classList.add('active')
        product_item.setAttribute('index', idx)
        product_item.innerHTML = `
          <a class="product-item__link" href="/collections/all/products/${ product.handle }">
            <div class="product-item__image-wrapper lazy-container">
              <img data-sizes="auto" data-src="${ product.images[0] }" class="lazyload" alt="${ product.title }" />
            </div>
            <span class="product-item__title">
              ${ product.title }
            </span>
            <p class="product-item__price">
              ${ formatMoney(product.variants[0].price) }
            </p>
            <!-- include 'wishlist-button-collection' with '${ product.id }' -->
          </a>`
        document.querySelector('.product__recommendations .slider__track').appendChild(product_item)
      })
    })
  }

}

if (document.querySelector('body').classList.contains('template-product')) {
  window.PStemplates.loadProduct()
}

function onOptionChange (event) {
  const variant = event.dataset.variant
  const selectedVariantElement = document.querySelector(selectors.selectedVariant)

  renderDropdownCombinations(false)

  renderImages(variant)
  renderPrice(variant)
  renderComparePrice(variant)

  selectedVariantElement.value = variant.id

  window.PSVueProduct.$refs.quantity.optionChanged(variant)

  updateBrowserHistory(variant)
}

function renderImages (variant) {
  if (!variant || variant.featured_image === null) return
  slideToVariantImage(variant.featured_image.position)
}

function renderPrice (variant) {
  const priceElement = document.querySelector(selectors.productPrice)
  const priceWrapperElement = document.querySelector(selectors.priceWrapper)

  priceWrapperElement.classList.toggle(classes.hide, !variant)

  if (variant) {
    priceElement.innerText = formatMoney(variant.price, theme.moneyFormat)
  }
}

function renderComparePrice (variant) {
  if (!variant) {
    return;
  }

  const comparePriceElement = document.querySelector(selectors.comparePrice)
  const compareTextElement = document.querySelector(selectors.comparePriceText)

  if (!comparePriceElement || !compareTextElement) {
    return;
  }

  if (variant.compare_at_price > variant.price) {
    comparePriceElement.innerText = formatMoney(
      variant.compare_at_price,
      theme.moneyFormat,
    );
    compareTextElement.classList.remove(classes.hide);
    comparePriceElement.classList.remove(classes.hide);
  } else {
    comparePriceElement.innerText = '';
    compareTextElement.classList.add(classes.hide);
    comparePriceElement.classList.add(classes.hide);
  }
}

function slideToVariantImage (pos) {
  window.product_gallery_slider.goTo(pos - 1)
}

function updateBrowserHistory (variant) {
  if (!variant) return
  const url = getUrlWithVariant(window.location.href, variant.id)
  window.history.replaceState({ path: url }, '', url)
}

function renderDropdownCombinations (firstload) {
  const option1 = document.querySelectorAll(selectors.optionsDropdown)[0]
  const option2 = document.querySelectorAll(selectors.optionsDropdown)[1]

  if (option1 === undefined || option2 === undefined) return
  if (option1.nodeName != 'SELECT' || option2.nodeName != 'SELECT') return

  // First dropdown
  const firstOptions = option1.options
  let first_possibles = []
  variants.forEach((variant) => {
    if (variant.options.includes(option2.value)) {
      first_possibles.push(variant.options)
    }
  })
  for (let option of firstOptions) {
    const value = option.value
    let flag = false
    first_possibles.forEach(possible => {
      if (possible.includes(value)) {
        flag = true
      }
    })
    if (flag === false) {
      option.removeAttribute('selected')
      option.setAttribute('disabled', 'disabled')
    } else {
      option.removeAttribute('disabled')
    }
  }
  if (firstload) {
    option1.querySelector(':not([disabled="disabled"])').setAttribute('selected', 'selected')
  }

  // Second dropdown
  const secondOptions = option2.options
  let second_possibles = []
  variants.forEach((variant) => {
    if (variant.options.includes(option1.value)) {
      second_possibles.push(variant.options)
    }
  })
  for (let option of secondOptions) {
    const value = option.value
    let flag = false
    second_possibles.forEach(possible => {
      if (possible.includes(value)) {
        flag = true
      }
    })
    if (flag === false) {
      option.removeAttribute('selected')
      option.setAttribute('disabled', 'disabled')
    } else {
      option.removeAttribute('disabled')
    }
  }
  if (firstload) {
    option2.querySelector(':not([disabled="disabled"])').setAttribute('selected', 'selected') 
  }
}
